import React, { useEffect, useState } from 'react';
import servicesApi from '../../seller-apis/servicesApi';
import api from '../../seller-apis/api';
import Button from './Button';
import './brand.css';
import { Badge, Col, Container, Modal, Row } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import Loader from '../common/Loader';
import { useAlert } from 'react-alert';
import { brandSubscriptionPaymentHandler } from '../../utilities/razorPay';
import BrandStepTimeLine from './BrandStepTimeline';
import SubscriptionSuccess from './SubscriptionSuccess';

function BrandStep2() {
    const { id } = useParams();
    const alert = useAlert();
    const history = useHistory();
    const [modal, setModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [brand, setBrand] = useState({})
    const [showSuccess, setShowSuccess] = useState(false)
    const [disable, setDisable] = useState(true)
    const [hoveredIndex, setHoveredIndex] = React.useState(null);
    //Subscription Plans
    //Live
    /*const SUBSCRIPTION_PLANS = {
        '3': 'plan_QPahHwsmEwddCJ',
        '6': 'plan_QPahy4V8BH9o2u',
        '12': 'plan_QPaiZc2at7b8ks'
    }*/
    //Testing
    /*const SUBSCRIPTION_PLANS = {
        '3': 'plan_QIvQ5SpzmwEy5S',
        '6': 'plan_QIvRE4TPLBmO4X',
        '12': 'plan_QIvQdd5RXnUyVR'
    }*/
    useEffect(() => {
        setShowSuccess(false)
        if (!id) {
            alert.error("No brand selected.")
            return null;
        }
        else {
            fetchBrand(id)
        }
    }, [])

    const fetchBrand = async (id) => {
        try {
            setLoader(true)
            const res = await api.TradeMark.getBrandById(id);
            setBrand(res?.data?.data?.records)
            console.log(res.data.data.records)
            if (res.data.data.totalRecords < 1) {
                alert.error("Brand not found.")
                history.replace("/apply-brand/1");
                return null;
            }
            if (res?.data?.data?.records?.status === "ACTIVE") {
                setDisable(false)
                /*if (res?.data?.data?.records?.subscription_status === "SUBSCRIBED") {
                    history.replace("/apply-brand/1");
                }*/
            }
            setLoader(false)
        } catch (error) {
            console.error(error)
        }
    }

    const submit = async () => {
        if (disable) return;
        try {
            if (Number(selectedPrice) !== 18000 && Number(selectedPrice) !== 30000 && Number(selectedPrice) !== 50000) {
                alert.error("Please select a valid plan.")
                return;
            }
            setModal(true)
        } catch (error) {
            console.error(error)
            alert("Some error has occurred!")
        }

    }

    const handleSubscription = () => {
        const totalAmt = `${selectedPrice}`
        //Plan Duration
        const plan_duration = totalAmt == 50000 ? 12 : totalAmt == 30000 ? 6 : 3
        //const plan_id = SUBSCRIPTION_PLANS[plan_duration + '']
        brandSubscriptionPaymentHandler(/*plan_id,*/ plan_duration, totalAmt, id).then(({data,status}) => {
            if (data == "Amount exceeds maximum amount allowed.") {
                alert.error(data);
            }
            else if(status === "failed"){
                setModal(false)
                alert.info("Payment failed")
            }
            else {
                setModal(false)
                setShowSuccess(true)
            }
        }).catch((err) => {
            console.log(err);
        });

    }

    const handleCardChange = (e) => {
        const price = e.target.value;
        setSelectedPrice(Number(price));
        setDisable(false)
    }

    const features = [
        {
            title: "Verified Badge",
            description: "For Brand Trust"
        },
        {
            title: "Brand Store",
            description: "Professional Catalog for Branding & Marketing"
        },
        {
            title: "Listing Exclusivity",
            description: "Other sellers cannot sell on your listings"
        },
        {
            title: "Priority Support",
            description: "Get Priority Support from the Toolsvilla team"
        },
        {
            title: "Brand URL",
            description: "Share your exclusive brand page for organic growth"
        }
    ];

    const styles = {
        container: {
            width: '100%',
            padding: '0 16px',
            // backgroundColor: '#f8f9fa',
            boxSizing: 'border-box',
            overflowX: 'auto',
            marginBottom:'20px'
        },
        row: {
            display: 'flex',
            flexWrap: 'nowrap',
            width: '100%',
            minWidth: '950px'
        },
        column: {
            flex: '1',
            padding: '0 8px',
            boxSizing: 'border-box'
        },
        card: {
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
            padding: '10px',
            textAlign: 'center',
            height: '100%',
            borderTop: '3px solid #165b5b',
            transition: 'box-shadow 0.3s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        cardHover: {
            boxShadow: '0 3px 8px rgba(0,0,0,0.12)'
        },
        titleRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '4px'
        },
        icon: {
            fill: '#28a745',
            width: '16px',
            height: '16px',
            marginRight: '6px'
        },
        title: {
            fontWeight: 'bold',
            fontSize: '14px',
            margin: 0,
            color: '#333'
        },
        description: {
            fontSize: '11px',
            color: '#666',
            margin: 0,
            lineHeight: '1.3'
        }
    };



    return (
        <div className='brand-step-main-cntn'>
            <div className='container'>
                <div className='row mb-5 mt-5 f-c-r'>

                    <div className='col-md-12 col-xs-12 col-sm-12 brand-left-cntn'>
                        {!showSuccess ?
                            <>
                                <div className='text-center mb-4'>
                                    <BrandStepTimeLine activeStep={2} />
                                    <h5>Select Your Plan</h5>
                                </div>
                                <div className='mb-4 brand-purchase-cntn'>
                                    <div className={`${selectedPrice === 50000 ? "brand-purchase-selected-card" : ""} brand-purchase-card`}>
                                        <div className='brand-purchase-select'>
                                            <input type='radio' name='price-card' className='brand-price-card-input' value={50000} onChange={handleCardChange} />
                                            {/* <div className='brand-purchase-card-tag'>
                                        POPULAR
                                    </div> */}
                                        </div>
                                        <div className='brand-purchase-duration'>
                                            1 Year
                                        </div>
                                        <div className='brand-purchase-price'>
                                            <i className="fa fa-inr"></i> 50,000
                                            <Badge bg="success">Save 30%</Badge>
                                            {/* <span className='price-save'>Save 30%</span> */}
                                        </div>
                                        <div className='dis-comparison'>
                                            <p><span className='price-cut'> <i className="fa fa-inr"></i> 72000 </span><span className='fs-12 text-success'>(Save <i className="fa fa-inr"></i>22,000)</span>
                                                {/* <span className='price-save'>Save 30%</span> */}
                                            </p>
                                            <p className='price-month'><i className="fa fa-inr"></i> 4,167/mo </p>
                                            {/* <div className='brand-save-stmt'>
                                                <p>Save <i className="fa fa-inr"></i>22,000</p>
                                            </div> */}
                                        </div>
                                        {/* <div className='brand-purchase-features'>
                                            <p><img src='/brand/check-circle.png' alt='icon' /> Premium Brand Store Page</p>
                                            <p><img src='/brand/check-circle.png' alt='icon' /> Priority Seller Support</p>
                                        </div> */}


                                    </div>
                                    <div className={`${selectedPrice === 30000 ? "brand-purchase-selected-card" : ""} brand-purchase-card`}>
                                        <div className='brand-purchase-select'>
                                            <input type='radio' name='price-card' className='brand-price-card-input' value={30000} onChange={handleCardChange} />
                                        </div>
                                        <div className='brand-purchase-duration'>
                                            6 Months
                                        </div>
                                        <div className='brand-purchase-price'>
                                            <i className="fa fa-inr"></i> 30,000
                                            <Badge bg="success">Save 17%</Badge>
                                        </div>
                                        <div className='dis-comparison'>
                                            <p><span className='price-cut'> <i className="fa fa-inr"></i> 36000</span><span className='fs-12 text-success'>(Save <i className="fa fa-inr"></i>6,000)</span>
                                                {/* <span className='price-save'>Save 17%</span> */}
                                            </p>
                                            <p className='price-month'><i className="fa fa-inr"></i> 5,000/mo</p>
                                            {/* <p>Save <i className="fa fa-inr"></i>6,000 compared to monthly</p> */}
                                        </div>
                                        {/* <div className='brand-purchase-features'>
                                            <p><img src='/brand/check-circle.png' alt='icon' /> Premium Brand Store Page</p>
                                            <p><img src='/brand/check-circle.png' alt='icon' /> Priority Seller Support</p>
                                        </div> */}
                                        {/* <div className='brand-save-stmt'>
                                            <p>Save <i className="fa fa-inr"></i>6,000 compared to monthly</p>
                                        </div> */}

                                    </div>
                                    <div className={`${selectedPrice === 18000 ? "brand-purchase-selected-card" : ""} brand-purchase-card`}>
                                        <div className='brand-purchase-select'>
                                            <input type='radio' name='price-card' className='brand-price-card-input' value={18000} onChange={handleCardChange} />
                                        </div>
                                        <div className='brand-purchase-duration'>
                                            3 Months
                                        </div>
                                        <div className='brand-purchase-price'>
                                            <i className="fa fa-inr"></i> 18,000

                                        </div>
                                        <div className='dis-comparison'>
                                            <p className='price-month'><i className="fa fa-inr"></i> 6,000/mo</p>
                                        </div>
                                        {/* <div className='brand-purchase-features'>
                                            <p><img src='/brand/check-circle.png' alt='icon' /> Premium Brand Store Page</p>
                                            <p><img src='/brand/check-circle.png' alt='icon' /> Priority Seller Support</p>
                                        </div> */}

                                    </div>
                                </div>
                                <div className='text-center mb-1'>
                                    <h6>Brandstore advantages</h6>
                                </div>
                                <div style={styles.container}>
                                    <div style={styles.row}>
                                        {features.map((feature, index) => (
                                            <div key={index} style={styles.column}>
                                                <div
                                                    style={{
                                                        ...styles.card,
                                                        ...(hoveredIndex === index ? styles.cardHover : {})
                                                    }}
                                                    onMouseEnter={() => setHoveredIndex(index)}
                                                    onMouseLeave={() => setHoveredIndex(null)}
                                                >
                                                    <div style={styles.titleRow}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" style={styles.icon}>
                                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                        </svg>
                                                        <h5 style={styles.title}>{feature.title}</h5>
                                                    </div>
                                                    <p style={styles.description}>{feature.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className='d-flex'>
                                <Button
                                    value="Go to Step 1"
                                    style={{ 'margin': 'auto' }}
                                    iconBefore={true}
                                    icon={<i className={"me-2 bi bi-arrow-left"} />}
                                    handleClick={() => {history.replace('/apply-brand/1/'+id)}}
                                />
                                <Button
                                    value="Proceed to Payment"
                                    disabled={disable}
                                    style={{ 'margin': 'auto' }}
                                    icon={<i className={"ms-2 bi bi-arrow-right"} />}
                                    handleClick={() => submit()}
                                />
                                </div>
                               
                            </> : <>
                                <div className='text-center'>
                                    <BrandStepTimeLine activeStep={4} />
                                </div>
                                <SubscriptionSuccess />
                            </>
                        }

                    </div>
                </div>
            </div>
            <Modal show={modal} size="lg" className='brand-store-subscribe-modal' centered>
                <Modal.Body>

                    <div className="white-bg wallet-main">
                        <div className="wallet-container">
                            <div className="close-button" onClick={() => setModal(false)}>&times;</div>
                            <div className="inner-data">
                                <div className="title">Subscribe to Brand Store</div>

                                <div className="amt-details my-3">
                                    <div className="dis-flex justify-content-between">
                                        <div className="title">Original Amount</div>
                                        <div className="title">&#8377; {selectedPrice}</div>
                                    </div>
                                    <div className="dis-flex justify-content-between">
                                        <div className="title">Tax GST (18%)</div>
                                        <div className="title">&#8377; {Math.round((selectedPrice * 18) / 100)}</div>
                                    </div>
                                    <div className="dis-flex justify-content-between">
                                        <div className="title">Net Payble Amount</div>
                                        <div className="title text-right">&#8377; {Math.round(parseInt(selectedPrice) + ((parseInt(selectedPrice) * 18) / 100))}</div>
                                    </div>
                                    <div className="">
                                        <div className="title text-right fs-8">(including Tax)</div>
                                    </div>
                                </div>

                                <div className="wallet-button" onClick={() => handleSubscription()}>
                                    Proceed to Pay &#8377; {Math.round(parseInt(selectedPrice) + ((parseInt(selectedPrice) * 18) / 100))}
                                </div>
                                <div className="support-email text-center mt-3">For queries, write us to <span className="tv-color fw-bold">sellersupport@toolsvilla.com</span></div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
            <Loader show={loader} />
        </div>
    )

}

export default BrandStep2;